import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramArrow } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramArrow';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const ParallelDiagram = () => (
  <Diagram viewBox="0 0 340 150">
    <DiagramBox x={8} y={60} width={70} height={30} tone={BoxTone.REQUEST} />
    <DiagramText x={43} y={79} tone={TextTone.INVERSE} bold tId="REQUEST" />
    <DiagramArrow d="M78,75 C110,75 110,22 140,22" />
    <DiagramArrow d="M78,75 C110,75 110,57 140,57" />
    <DiagramArrow d="M78,75 C110,75 110,92 140,92" />
    <DiagramArrow d="M78,75 C110,75 110,127 140,127" />
    <DiagramText x={108} y={12} tone={TextTone.MUTED} small tId="AT_ONCE" />
    <DiagramBox x={142} y={10} width={78} height={24} tone={BoxTone.YES} />
    <DiagramText x={181} y={26} tone={TextTone.YES} bold tId="APPROVES">
      {'A · '}
    </DiagramText>
    <DiagramBox x={142} y={45} width={78} height={24} tone={BoxTone.NO} />
    <DiagramText x={181} y={61} tone={TextTone.NO} tId="REJECTS">
      {'B · '}
    </DiagramText>
    <DiagramBox x={142} y={80} width={78} height={24} tone={BoxTone.YES} />
    <DiagramText x={181} y={96} tone={TextTone.YES} bold tId="APPROVES">
      {'C · '}
    </DiagramText>
    <DiagramBox x={142} y={115} width={78} height={24} tone={BoxTone.MAYBE} />
    <DiagramText x={181} y={131} tone={TextTone.MAYBE} tId="REVIEW">
      {'D · '}
    </DiagramText>
    <DiagramArrow d="M220,22 C250,22 250,60 268,60" />
    <DiagramArrow d="M220,92 C250,92 250,66 268,66" />
    <DiagramBox x={270} y={46} width={64} height={34} tone={BoxTone.HIGHLIGHT} />
    <DiagramText x={302} y={60} bold>
      Ranking
    </DiagramText>
    <DiagramText x={302} y={73} tone={TextTone.MUTED} small tId="WINS">
      {'A · '}
    </DiagramText>
  </Diagram>
);
